import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/cat.png"

export const Contact = () => {
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    }
    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState("Send");
    const [status, setStatus] = useState({});
    const [errors, setErrors] = useState({});

    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        })
        setErrors({ ...errors, [category]: false });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};
        if (!formDetails.firstName) newErrors.firstName = true;
        if (!formDetails.lastName) newErrors.lastName = true;
        if (!formDetails.email) newErrors.email = true;
        if (!formDetails.message) newErrors.message = true;

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setStatus({ success: false, message: 'Please fill in all mandatory fields.' });
            return; 
        }

        setButtonText("Sending...");
        let response = await fetch(process.env.PORT || 'http://localhost:5000/contact', {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(formDetails)
    });
    setButtonText("Send");
    let result = await response.json()
    setFormDetails(formInitialDetails);
    if (result.code === 200){
        setStatus({ success: true, message: 'Message sent successfully'});
    } else {
        setStatus({ success: false, message: 'Something went wrong, please try again later.'});
    }
}

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                    <img src={contactImg} alt="Contact Me"/>
                    </Col>
                    <Col md={6}>
                    <h2>Get in Touch!</h2>
                        <h3>New feature coming here soon...</h3>
                        In the meantime, if you're curious about my CV or just want to have a chat, feel free to find my contact details by clicking the button in the menu or in the footer at the bottom of this page. You’ll find my email and LinkedIn there, and I’d love to connect!
                    {/* <form onSubmit={handleSubmit}>
                        <Row>
                            <Col sm={6} className="px-1">
                                <input 
                                    type="text" 
                                    value={formDetails.firstName} 
                                    placeholder="*First Name" 
                                    onChange={(e) => onFormUpdate('firstName', e.target.value)}
                                    className={errors.firstName ? 'error' : ''} />
                            </Col>
                            <Col sm={6} className="px-1">
                                <input 
                                    type="text" 
                                    value={formDetails.lastName} 
                                    placeholder="*Last Name" 
                                    onChange={(e) => onFormUpdate('lastName', e.target.value)} 
                                    className={errors.lastName ? 'error' : ''} />
                            </Col>

                            <Col sm={6} className="px-1">
                                <input 
                                    type="email" 
                                    value={formDetails.email} 
                                    placeholder="*Email" 
                                    onChange={(e) => onFormUpdate('email', e.target.value)}
                                    className={errors.email ? 'error' : ''} />
                            </Col>
                            <Col sm={6} className="px-1">
                                <input 
                                    type="tel" 
                                    value={formDetails.phone} 
                                    placeholder="Phone No." 
                                    onChange={(e) => onFormUpdate('phone', e.target.value)} />
                            </Col>

                            <Col>
                                <textarea 
                                    row ="6"
                                    value={formDetails.message} 
                                    placeholder="*Message" 
                                    onChange={(e) => onFormUpdate('message', e.target.value)} 
                                    className={errors.message ? 'error' : ''} />

                                <button type="submit"><span>{buttonText}</span></button>
                            </Col>

                            {
                                status.message && 
                                <Col>
                                    <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                                </Col>
                            }
                        
                        </Row>
                    </form> */}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}